import SearchTravelAdvance from './components/SearchTravelAdvance/SearchTravelAdvance.vue'
import TableTravelAdvance from './components/TableTravelAdvance/TableTravelAdvance.vue'
import ModaAddTravelAdvance from './components/ModaAddTravelAdvance/ModaAddTravelAdvance.vue'
import DetailsTravelAdvanced from './components/DetailsTravelAdvanced/DetailsTravelAdvanced.vue'
import TableTravelComision from './components/TableTravelComision/TableTravelComision.vue'
import DetailsTravelComission from './components/DetailsTravelComission/DetailsTravelComission.vue'

export default {
  name: 'TravelReimbursement',
  components: {SearchTravelAdvance, TableTravelAdvance, ModaAddTravelAdvance, DetailsTravelAdvanced, TableTravelComision, DetailsTravelComission},
  data () {
    return {
      tabs: 0,
      flEdit: false,
      fladvanced: false,
      dataDetails: [],
      selectedIds: [],
      modalKey: 0
    }
  },
  methods: {
    show () {
      // this.$refs.ModaAddTravelAdvance.show()
      this.modalKey++
      this.$nextTick(() => this.$refs.ModaAddTravelAdvance.show())
    },
    editAdiantamento (obj) {
      this.flEdit = true
      this.fladvanced = true
      this.dataDetails = obj
    },
    editAcount (obj) {
      this.flEdit = true
      this.fladvanced = false
      this.dataDetails = obj
    },
    search (obj) {
      let data = this.transformObject(obj)
      if (this.tabs === 0) {
        this.$refs.TableTravelAdvance.dataFilter = data
        this.$refs.TableTravelAdvance.onLoad(data)
      } else {
        this.$refs.TableTravelComision.dataFilter = data
        this.$refs.TableTravelComision.getAll(data)
      }
    },
    transformObject (obj) {
      let data = {}
      Object.keys(obj).forEach((Element) => {
        data[Element] = obj[Element].value
      })
      return data
    },
    addSucces () {
      this.$refs['add-travel-concluido'].show()
    },
    closeCon () {
      this.$refs['add-travel-concluido'].hide()
      this.$refs.TableTravelAdvance.onLoad()
    },
    cloneAdvance (data) {
      this.$refs.ModaAddTravelAdvance.show(0)
      this.$refs.ModaAddTravelAdvance.clone(data)
    },
    searchDespe () {

    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/travelreimbursement/travelreimbursement.js